import { GetTransactionsParams } from "@/models/payload/transaction";
import clubRequest from "../axios";

const getTransactions = async (params: GetTransactionsParams) =>
  (await clubRequest.transactionList(params)).data;

const getTransactionById = async (id: number) =>
  (await clubRequest.transactionCreditList({ id })).data;

const transactionService = {
  getTransactions,
  getTransactionById,
};

export default transactionService;
